export default angular.module('BaseClass.validatable.errors.duplicate_validator_error',[])
    .factory('BCVDuplicateValidatorError', function() {
        function DuplicateValidatorError(name, list) {
            this.name = 'DuplicateValidatorError';
            this.message = "A validator by the name '" + name + "' has already been registered.";
            this.list = list;
        }

        DuplicateValidatorError.prototype = Error.prototype;
        return DuplicateValidatorError;
    }).name;
